import { CircularProgress, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton } from "@mui/material";
import MDButton from "components/MDButton";
import CloseIcon from "@mui/icons-material/Close";
import { useSelector } from "react-redux";
import { fetchMembersDetails, updateCardBlock } from "../../redux/slices/member";
import { openSnackbar } from "../../redux/slices/common";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getMemberDetailsbyEmail, updateMember } from "../../redux/slices/hyperwolf/members";

export default function ActiveCard({ closeModal }) {
    const { modalData } = useSelector(state => state.modal);
    const { memberId, platform, memberEmail } = modalData
    const { loading = false } = useSelector(state => state.members) || {};
    const { loading: load } = useSelector(state => state?.hyperwolfMemberSlice) || {};

    const dispatch = useDispatch()

    const handleSubmitActive = () => {
        if (platform === 'hw') {
            let payload = {
                "memberEmail": memberEmail,
                status: false,
            };
            dispatch(updateMember({ email: memberEmail, data: payload })).unwrap()
                .then((res) => {
                    showError(res?.message, 'success');
                    dispatch(getMemberDetailsbyEmail(memberEmail));
                    closeModal()
                }).catch((err) => {
                    showError(err?.message, 'error');
                })
        } else {
            let payload = {
                "memberId": memberId,
                status: false,
            };
            dispatch(updateCardBlock({ data: payload })).unwrap().then((res) => {
                showError(res?.message, 'success');
                dispatch(fetchMembersDetails(memberId));
                // dispatch(fetchMemberOrders({ filters: {}, memberId }));
                // navigate('/members');
                closeModal()
            }).catch((err) => {
                showError(err?.message, 'error');
            });

        }
    }

    const showError = (message, errortype) => {
        if (errortype === 'success') {
            dispatch(openSnackbar({ content: message, color: 'success', icon: 'check' }));
        }
        if (errortype === 'error') {
            dispatch(openSnackbar({ content: message, color: 'error', icon: 'warning' }));
        }
    };
    return (
        <div className="active-card-container">
            <DialogTitle id='draggable-dialog-title' display='flex' alignItems='center' justifyContent='space-between'>
                Update
                <IconButton onClick={closeModal} edge='end' size='small'>
                    <CloseIcon fontSize='medium' />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Are you sure you want to make the card payment active?
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <MDButton onClick={closeModal} size='small' color='secondary'>
                    Cancel
                </MDButton>
                <MDButton
                    onClick={() => handleSubmitActive()}
                    disabled={loading || load}
                    loading={loading || load}
                    size='small'
                    color="primary"
                    type="button"
                    variant="contained"
                >
                    Save
                </MDButton>
            </DialogActions></div>
    )
}